// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% {
    filter: opacity(.45) blur(4px);
  }
  100% {
    filter: opacity(.65) blur(1px);
  }
`

export const MaintenanceWindowMessageContainer = styled.div`
  align-items: center; 
  background-color: #000;
  flex: 1;
  height: 100%;
  justify-content: center;
  position: relative;
  
  &::before {
    animation: 3s ${pulse} ease-in-out infinite alternate;
    background-image: url(${({ bgImage }) => bgImage});
    background-size: cover;
    content: ' ';
    left: 0;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
  }
  
  > div {
    background-color: white;
    border: thick solid #335c84; // $blue-dark
    border-radius: .25em;
    padding: 1em;
    position: relative; // assigns correct stacking order w ::before sibling.
    box-shadow: 0 0 .125em .125em rgba(255, 255, 255, .15);
  }
`

